var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Stack, Typography, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import { DocumentManagementIcon } from "../../components/icons";
import DocumentLogo from "../../assets/images/document.svg";
import TextField from "../../components/FormComponents/TextField";
import { colors } from "../../Themes/colors";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import { CustomSwitch } from "../../components/uiComponents/CustomSwitch";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
var FILE_TYPE_GROUPS = [
    { id: "jpeg", label: "JPEG Images", extensions: ["jpg", "jpeg"] },
    { id: "pdf", label: "PDF Documents", extensions: ["pdf"] },
    { id: "word", label: "Word Documents", extensions: ["doc", "docx"] },
    { id: "excel", label: "Excel Spreadsheets", extensions: ["xls", "xlsx"] },
    { id: "text", label: "Text Files", extensions: ["txt"] },
    { id: "csv", label: "CSV Files", extensions: ["csv"] },
    { id: "xml", label: "XML Files", extensions: ["xml"] },
];
var CustomerPortalDocumentSize = function () {
    var location = useLocation();
    var _a = useState([]), extensionsList = _a[0], setExtensionList = _a[1];
    var _b = useState(""), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState(null), currentDocumentSize = _c[0], setCurrentDocumentSize = _c[1];
    var _d = useState(0), id = _d[0], setId = _d[1];
    var _e = useState(false), allowedExtensionsCollapsed = _e[0], setAllowedExtensionsCollapsed = _e[1];
    var _f = useState(null), togglingGroupId = _f[0], setTogglingGroupId = _f[1];
    var _g = useState(false), dataUnavailable = _g[0], setDataUnavailable = _g[1];
    var documentSize = useCustomerPortalPermissions().documentSize;
    var canUpdate = documentSize.canEdit;
    var allowedSet = React.useMemo(function () {
        var set = new Set();
        extensionsList.forEach(function (e) {
            var ext = (e.Extension || "").toLowerCase().replace(/^\./, "");
            if (ext && (e.IsAccessible === undefined || e.IsAccessible === 1)) {
                set.add(ext);
            }
        });
        return set;
    }, [extensionsList]);
    var isGroupEnabled = function (group) {
        return group.extensions.every(function (ext) { return allowedSet.has(ext.toLowerCase()); });
    };
    var enabledCount = FILE_TYPE_GROUPS.filter(function (g) { return isGroupEnabled(g); }).length;
    var totalCount = FILE_TYPE_GROUPS.length;
    var fetchAllExtensions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, error_1, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_GET_ALL_EXTENSIONS),
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        setExtensionList((_a = apiResponse.data) !== null && _a !== void 0 ? _a : []);
                        setDataUnavailable(false);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _d.sent();
                    setDataUnavailable(true);
                    console.error("Error updating user:", error_1);
                    errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        "Failed to update user";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        fetchDocumentSize();
    }, [location.key]);
    var fetchDocumentSize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, value, numericValue, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_LIST_DOCUMENT_SIZE,
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        value = response.data.data.Value;
                        numericValue = typeof value === "string"
                            ? parseInt(value.replace(/[^0-9]/g, ""), 10) || 0
                            : Number(value) || 0;
                        setCurrentDocumentSize(numericValue);
                        setId(response.data.data.Id);
                        setDataUnavailable(false);
                    }
                    else {
                        setDataUnavailable(true);
                    }
                    fetchAllExtensions();
                    return [3, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error fetching document size:", error_2);
                    setDataUnavailable(true);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var addExtensionApi = function (extension) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, api_service.post({
                        endPoint: api_urls.CUSTOMER_PORTAL_ADD_EXTENSION,
                        payLoad: { extension: extension },
                        showLoader: false,
                    })];
                case 1:
                    response = _b.sent();
                    return [2, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200];
            }
        });
    }); };
    var updateDocumentSize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!inputValue || inputValue === "" || Number(inputValue) === 0) {
                        utility.alert("Please enter a valid number", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_UPDATE_DOCUMENT_SIZE,
                            payLoad: {
                                id: Number(id),
                                value: Number(inputValue),
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Document size updated successfully", constants.TOAST_TYPES.INFO);
                        setInputValue("");
                        fetchDocumentSize();
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update document size", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 4];
                case 3:
                    error_3 = _d.sent();
                    console.error("Error updating document size:", error_3);
                    errorMessage = ((_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                        "Failed to update document size";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var deleteExtensionApi = function (extension) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, api_service.delete({
                        endPoint: api_urls.CUSTOMER_PORTAL_DELETE_EXTENSION,
                        payLoad: { extension: extension },
                        showLoader: false,
                    })];
                case 1:
                    response = _b.sent();
                    return [2, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200];
            }
        });
    }); };
    var handleGroupToggle = function (group) { return __awaiter(void 0, void 0, void 0, function () {
        var enabled, _i, _a, ext, _b, _c, ext, error_4, errorMessage;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    enabled = isGroupEnabled(group);
                    setTogglingGroupId(group.id);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 12, 13, 14]);
                    if (!enabled) return [3, 6];
                    _i = 0, _a = group.extensions;
                    _f.label = 2;
                case 2:
                    if (!(_i < _a.length)) return [3, 5];
                    ext = _a[_i];
                    return [4, deleteExtensionApi(ext)];
                case 3:
                    _f.sent();
                    _f.label = 4;
                case 4:
                    _i++;
                    return [3, 2];
                case 5: return [3, 10];
                case 6:
                    _b = 0, _c = group.extensions;
                    _f.label = 7;
                case 7:
                    if (!(_b < _c.length)) return [3, 10];
                    ext = _c[_b];
                    return [4, addExtensionApi(ext)];
                case 8:
                    _f.sent();
                    _f.label = 9;
                case 9:
                    _b++;
                    return [3, 7];
                case 10: return [4, fetchAllExtensions()];
                case 11:
                    _f.sent();
                    utility.alert(enabled ? "".concat(group.label, " disabled.") : "".concat(group.label, " enabled."), constants.TOAST_TYPES.INFO);
                    return [3, 14];
                case 12:
                    error_4 = _f.sent();
                    errorMessage = ((_e = (_d = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) ||
                        (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) ||
                        "Failed to update extensions";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 14];
                case 13:
                    setTogglingGroupId(null);
                    return [7];
                case 14: return [2];
            }
        });
    }); };
    return (React.createElement(Box, { sx: { p: 3 } },
        React.createElement(CommonHeader, { mainTitle: "Document Size", subTitle: "Manage document access, allowed file types, and size limits.", icon: React.createElement(Box, { sx: { "& svg": { height: 24, width: 24 }, height: 24 } },
                React.createElement(DocumentManagementIcon, null)) }),
        React.createElement(Stack, { mt: 3 }, dataUnavailable ? (React.createElement(Box, { sx: {
                py: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: colors.greyShades[15],
            } },
            React.createElement(Typography, { variant: "body1" }, "No Action available."))) : (React.createElement(Grid, { container: true, spacing: 3 },
            React.createElement(Grid, { item: true, xs: 12, md: 7 },
                React.createElement(Stack, { gap: 2 },
                    React.createElement(Box, { sx: {
                            border: "1px solid ".concat(colors.greyShades[18]),
                            borderRadius: 3,
                            overflow: "hidden",
                            bgcolor: colors.fullWhite,
                            boxShadow: "0 1px 3px rgba(16, 24, 40, 0.06)",
                            opacity: canUpdate ? 1 : 0.6,
                        } },
                        React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", onClick: function () {
                                return setAllowedExtensionsCollapsed(!allowedExtensionsCollapsed);
                            }, gap: 2, sx: {
                                px: 3,
                                py: 2.5,
                                cursor: "pointer",
                                "&:hover": { bgcolor: colors.greyShades[21] },
                            } },
                            React.createElement(Stack, { sx: { minWidth: 0 } },
                                React.createElement(Typography, { variant: "subtitle1", fontWeight: 600 }, "Allowed Extensions"),
                                React.createElement(Typography, { variant: "body2", sx: { color: colors.greyShades[15], mt: 0.5 } }, "Select the file types a borrower can upload to the portal.")),
                            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5, sx: { flexShrink: 0 } },
                                React.createElement(Box, { sx: {
                                        px: 1.5,
                                        py: 0.5,
                                        borderRadius: 10,
                                        whiteSpace: "nowrap",
                                        bgcolor: colors.greyShades[17],
                                        typography: "body2",
                                        fontWeight: 500,
                                        color: colors.greyShades[13],
                                    } },
                                    enabledCount,
                                    " of ",
                                    totalCount,
                                    " enabled"),
                                React.createElement(ExpandMoreIcon, { sx: {
                                        color: colors.greyShades[15],
                                        transform: allowedExtensionsCollapsed
                                            ? "rotate(0deg)"
                                            : "rotate(180deg)",
                                        transition: "transform 0.2s",
                                    } }))),
                        React.createElement(Collapse, { in: !allowedExtensionsCollapsed },
                            React.createElement(Stack, { sx: { borderTop: "1px solid ".concat(colors.greyShades[18]) } }, FILE_TYPE_GROUPS.map(function (group) {
                                var enabled = isGroupEnabled(group);
                                var busy = togglingGroupId === group.id;
                                return (React.createElement(Stack, { key: group.id, direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                                        px: 3,
                                        py: 1.5,
                                        borderBottom: "1px solid ".concat(colors.greyShades[20]),
                                        "&:last-of-type": { borderBottom: "none" },
                                        "&:hover": { bgcolor: colors.greyShades[21] },
                                    } },
                                    React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5 },
                                        React.createElement(Typography, { variant: "body2", fontWeight: 500, sx: { minWidth: 150 } }, group.label),
                                        React.createElement(Stack, { direction: "row", spacing: 0.75, flexWrap: "wrap" }, group.extensions.map(function (ext) { return (React.createElement(Box, { key: ext, sx: {
                                                px: 1,
                                                py: 0.25,
                                                borderRadius: 1,
                                                border: "1px solid ".concat(colors.greyShades[18]),
                                                bgcolor: colors.greyShades[14],
                                                typography: "caption",
                                                color: colors.greyShades[13],
                                            } },
                                            ".",
                                            ext)); }))),
                                    React.createElement(CustomSwitch, { checked: enabled, disabled: busy || !canUpdate, onChange: function () { return handleGroupToggle(group); }, activeColor: colors.blueShades[12], inactiveColor: colors.greyShades[12] })));
                            })))))),
            React.createElement(Grid, { item: true, xs: 12, md: 5 },
                React.createElement(Stack, { gap: 3 },
                    React.createElement(Stack, { sx: {
                            border: "1px solid ".concat(colors.greyShades[18]),
                            borderRadius: 3,
                            bgcolor: colors.fullWhite,
                            boxShadow: "0 1px 3px rgba(16, 24, 40, 0.06)",
                            px: 3,
                            py: 2.5,
                            gap: 1.5,
                        } },
                        React.createElement(Stack, { direction: "row", alignItems: "end", spacing: 2, sx: {
                                width: "100%",
                                "& .custom-select-container": {
                                    width: "100%",
                                },
                            } },
                            React.createElement(Stack, { sx: { width: "100%" } },
                                React.createElement(TextField, { label: "Allowed File Extensions", name: "Maxuploadfilesize", isMandatoryField: false, placeholder: "Maximum Upload Size", fullWidth: true, disabled: !canUpdate, onChange: function (e) {
                                        var value = e.target.value;
                                        if (value === "" || /^\d+$/.test(value)) {
                                            setInputValue(value);
                                        }
                                    }, value: inputValue, type: "text" })),
                            React.createElement(Button, { variant: "contained", color: "primary", sx: {
                                    "&.MuiButtonBase-root": {
                                        mb: 0.5,
                                    },
                                }, disabled: !canUpdate ||
                                    !inputValue ||
                                    inputValue === "" ||
                                    Number(inputValue) === 0, onClick: function () { return updateDocumentSize(); } }, "Add")),
                        currentDocumentSize !== null && (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: {
                                alignSelf: "flex-start",
                                px: 1.5,
                                py: 0.75,
                                borderRadius: 2,
                                bgcolor: colors.greyShades[21],
                            } },
                            React.createElement(Typography, { variant: "body2", sx: { color: "text.secondary", fontWeight: 500 } }, "Configured Upload Limit:"),
                            React.createElement(Typography, { variant: "body2", sx: { color: "text.primary", fontWeight: 600 } },
                                currentDocumentSize,
                                " MB")))),
                    React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: { py: 2 } },
                        React.createElement("img", { src: DocumentLogo, alt: "document size", style: { maxWidth: "100%", maxHeight: 260 } })))))))));
};
export default CustomerPortalDocumentSize;
